/**
 * Unit component - marks an entity as a unit with a type
 */

import type { UnitType } from '@/types';

export interface UnitComponent {
  unitType: UnitType;
}

export function createUnit(unitType: UnitType): UnitComponent {
  return { unitType };
}
